import { HybridServiceAccessor } from "@app/common/hybrid-service-accessor";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { GroupService as GroupService2 } from "@app/services/groups/group.service";
import * as angular from "angular";
import { IGroup } from "../main/components/resourceManagement/groups/_models/IGroup";

/**
 * @deprecated This class is hosted only for compatibility with AngryJS components.
 * Use new `GroupService` instead, it has all functionalities.
 */
export class GroupService {
    private readonly groupsService2 = new HybridServiceAccessor<GroupService2>(
        "groupService2", 
        this.$injector
    );

    static $inject = ["$injector"];

    constructor(
        private readonly $injector: angular.auto.IInjectorService
    ) { }

    addGroupsIdsToVehicles = this.groupsService2.service.addGroupsIdsToVehicles;
    findGroup = this.groupsService2.service.findGroup
    findGroupIdsAssetBelongsTo = this.groupsService2.service.findGroupIdsAssetBelongsTo;
    findDepotsWithHomeLocations = this.groupsService2.service.findDepotsWithHomeLocations;
    getGroupComboBox = this.groupsService2.service.getGroupComboBox;

    getGroups(invalidateCache: boolean = false): angular.IPromise<IGroup[]> {
        return this.groupsService2.service.getGroups(invalidateCache) as angular.IPromise<IGroup[]>;
    }

    getGroupsWithFullMappings(invalidateCache: boolean = false): angular.IPromise<IGroupWithIds[]> {
        return this.groupsService2.service.getGroupsWithIds(invalidateCache) as angular.IPromise<IGroupWithIds[]>;
    }

    groupNameExists(groupName: string, existingGroupId: number): angular.IPromise<boolean> {
        return this.groupsService2.service.groupExists(groupName, existingGroupId) as angular.IPromise<boolean>;
    }
}
